import api from "./api";

export type CampaignFilters = {
  target_roles?: string[];
  target_platforms?: string[];
  target_club_id?: string | null;
};

export type CampaignPreview = {
  device_count: number;
  user_count: number;
  breakdown: { android: number; ios: number };
};

export type PushCampaign = {
  id: string;
  created_by: string;
  title: string;
  body: string;
  data: any;
  target_roles: string[];
  target_platforms: string[];
  target_club_id: string | null;
  device_count: number;
  sent_count: number;
  failed_count: number;
  status: string;
  sent_at: string;
  created_at: string;
  created_by_user?: {
    id: string;
    full_name: string | null;
    email: string;
  };
};

export async function previewPushCampaign(filters: CampaignFilters) {
  const { data } = await api.post<CampaignPreview>(
    "/admin/campaigns/preview",
    filters
  );
  return data;
}

export async function sendPushCampaign(payload: {
  title: string;
  body: string;
  data?: Record<string, string>;
} & CampaignFilters) {
  const { data } = await api.post<{
    campaign: PushCampaign;
    device_count: number;
    sent_count: number;
    failed_count: number;
  }>("/admin/campaigns", payload);
  return data;
}

export async function listPushCampaigns(params: { page?: number; pageSize?: number } = {}) {
  const { data } = await api.get<{
    data: PushCampaign[];
    total: number;
    page: number;
    pageSize: number;
  }>("/admin/campaigns", { params });
  return data;
}
